import { DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";

import { IrregularidadeCadastroComponent } from "./cadastro/irregularidade-cadastro.component";
import { IrregularidadeRoutingModule } from "./irregularidade-routing.module";
import { IrregularidadePesquisaComponent } from "./pesquisa/irregularidade-pesquisa.component";
import { IrregularidadeListagemComponent } from "./pesquisa/listagem/irregularidade-listagem.component";

@NgModule({
    imports:[
        SharedModule,
        IrregularidadeRoutingModule
    ],
    declarations:[
        IrregularidadeCadastroComponent,
        IrregularidadePesquisaComponent,
        IrregularidadeListagemComponent
    ],
    providers:[ 
        DatePipe
    ]
})
export class IrregularidadeModule{}